
import Vue from "vue";
declare var $: any;

export default Vue.extend({
  name: "Help",
  data() {
    return {};
  },
  mounted() {
    //使用JavaScript监听iframe元素的load事件，然后根据iframe中document的高度来动态调整iframe窗口的高度。
    // var testFrame = document.getElementById("testFrame");
    // testFrame.addEventListener("load", function () {
    //   testFrame.height = this.getHeight(testFrame.contentDocument);
    // });
  },
  methods: {
    getHeight(doc :any) {
      var body = doc.body,
        html = doc.documentElement;

      var height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );
      return height;
    },
  },
});
